// @ts-nocheck
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import React, { useCallback } from 'react';
import {
  ReactMuiTableV8,
  ReactMuiTableColumnHeaderTextEllipsis,
} from '@nuva-org/solytics-frontend';
import { isArray, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';

import { createDynamicColumns } from '../../../utils/Utils';
import DialogTransition from '../Transition/DialogTransition';
import NoDataFoundComponent from '../NoDataFoundComponent';

const handleOnTableStateChange = () => {};

const handleGetHeaderProps = () => ({
  style: {
    display: 'flex',
    alignItems: 'center',
  },
});

const handleRowProps = () => ({
  style: {
    position: 'relative',
  },
});

const handleGetColumnProps = () => {
  return {
    style: {
      textAlign: 'left',
      textOverflow: 'ellipsis',
      overflow: ' hidden',
      wordBreak: 'initial',
      whiteSpace: 'nowrap',
      paddingLeft: 10,
    },
  };
};

const PreviewTableChart = ({ open, handleClose, previewItem }) => {
  const tableData = previewItem?.item?.data || [];
  const columns = createDynamicColumns({
    data: previewItem?.item?.columns || [],
    width: 150,
    HeaderCell: ReactMuiTableColumnHeaderTextEllipsis,
    showTimeWithSeconds: true,
  });

  const handleClosePreview = useCallback(() => {
    handleClose();
  }, [handleClose]);

  const handleRowLevelOnHoverOptions = useCallback(() => {}, []);

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      TransitionComponent={DialogTransition}
    >
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          {previewItem?.title}
        </Box>
      </DialogTitle>

      <IconButton
        color="primary"
        aria-label="Close dialog"
        onClick={handleClosePreview}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container xs={12} mb={2} p={1}>
          {previewItem?.type === 'table' ? (
            <Grid item xs={12}>
              <Box
                sx={{
                  width: '100%',
                  maxHeight: `545px`,
                  overflow: 'scroll',
                }}
                p={2}
              >
                <ReactMuiTableV8
                  data={
                    tableData?.length > 0 && isArray(tableData) ? tableData : []
                  }
                  columns={isEmpty(columns) ? [] : columns}
                  initialHiddenColumns={[]}
                  initialColumnOrder={[]}
                  rowLevelOnHoverOptions={handleRowLevelOnHoverOptions}
                  getHeaderProps={handleGetHeaderProps}
                  getRowProps={handleRowProps}
                  getColumnProps={handleGetColumnProps}
                  enableRowSelection={false}
                  pageCount={tableData?.length}
                  enablePagination={true}
                  initialPageSize={10}
                  rowsPerPageOptions={[5, 10, 15]}
                  isAllOptionDisabled={true}
                  showOptions={false}
                  showToolbar={true}
                  enableVirtualization={false}
                  onTableStateChange={handleOnTableStateChange}
                  enableSearchBar={true}
                  NoDataFoundComponent={NoDataFoundComponent}
                />
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} justifyContent="center" alignItems="center">
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={
                    previewItem?.item?.includes('data:image/svg+xml;base64')
                      ? previewItem?.item
                      : `data:image/png;base64,${previewItem?.item}`
                  }
                  alt="chart"
                  style={{
                    height: '500px',
                    maxWidth: '100%',
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

PreviewTableChart.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  previewItem: PropTypes.shape({
    item: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    type: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default PreviewTableChart;
